var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React, { Children, useCallback } from "react";
export var QuiCardVariantEnum;
(function (QuiCardVariantEnum) {
    QuiCardVariantEnum["Default"] = "default";
    QuiCardVariantEnum["Danger"] = "danger";
    QuiCardVariantEnum["BrandGradient"] = "brand-gradient";
    QuiCardVariantEnum["BrandRoyal"] = "brand-royal";
    QuiCardVariantEnum["TipsAndGuidance"] = "tips-and-guidance";
})(QuiCardVariantEnum || (QuiCardVariantEnum = {}));
export const QuiCard = (_a) => {
    var { role, active, children, disabled, icon, iconColor, padding = "lg", variant = "default", className, onClick } = _a, otherProps = __rest(_a, ["role", "active", "children", "disabled", "icon", "iconColor", "padding", "variant", "className", "onClick"]);
    const sections = Children.toArray(children);
    const cardClassName = classNames(`qui-card`, {
        "qui-interactive": !!role,
        "qui-disabled": disabled,
        "qui-card-active": active,
        [`qui-card-variant-${variant}`]: !!variant && variant !== "default",
    }, className);
    const handleClick = useCallback((e) => !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e)), [onClick, disabled]);
    const handleKeyBindings = useCallback((e) => {
        if (e.key === "Enter" || e.key === " ") {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            handleClick(e);
        }
    }, [handleClick]);
    let iconColorDefault = "blue";
    switch (variant) {
        case "danger":
            iconColorDefault = "red";
            break;
        case "tips-and-guidance":
            iconColorDefault = "purple";
            break;
    }
    return (React.createElement("div", Object.assign({ className: cardClassName, tabIndex: role && !disabled ? 0 : undefined, role: role, onClick: handleClick, onKeyUp: handleKeyBindings, "aria-disabled": disabled }, otherProps),
        React.createElement("div", { className: "qui-card-content" }, sections.map((section, i) => (React.createElement("div", { key: i, className: `qui-card-section qui-inset-${padding.replace(" ", "-")} qui-flex-h-sm qui-align-top` },
            icon && i === 0 && (React.createElement("div", null,
                React.createElement("span", { className: `qui-card-icon qui-color-${iconColor !== null && iconColor !== void 0 ? iconColor : iconColorDefault}-500 qui-bg-${iconColor !== null && iconColor !== void 0 ? iconColor : iconColorDefault}-50` },
                    React.createElement("i", { className: `qui-icon-${icon}` })))),
            React.createElement("div", { style: { flex: 1 } }, section)))))));
};
